import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCycleSessions, saveCycleSessions, CycleSessionInput } from '@/api/cyclesService';
import { queryKeys } from '@/lib/queryKeys';
import { toaster } from '@/components/ui/toaster';

export const useCycleSessions = (cycleId: string) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKeys.pv2CycleSessions(cycleId),
    queryFn: () => getCycleSessions(cycleId),
    enabled: Boolean(cycleId),
  });

  const saveMutation = useMutation({
    mutationFn: (sessions: CycleSessionInput[]) => saveCycleSessions(cycleId, sessions),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.pv2CycleSessions(cycleId), data);
      queryClient.invalidateQueries({ queryKey: queryKeys.pv2Cycle(cycleId) });
      toaster.create({ title: 'Séances enregistrées', type: 'success' });
    },
    onError: (error) => {
      const message =
        (error as { response?: { data?: { message?: string } } })?.response?.data?.message ??
        'Enregistrement impossible.';
      toaster.create({ title: 'Enregistrement impossible', description: message, type: 'error' });
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    saveSessions: saveMutation.mutateAsync,
    isSaving: saveMutation.isPending,
  };
};
